import { FC } from 'react';
import { LabelTransformer, DiffBase } from '../diff-base';

const VacanciesDiff: FC = (props) => {
  const labelTransformer: LabelTransformer<'candidatePrioritizedVacancies'> = (el) => el.name;
  return <DiffBase multiple fieldName="candidatePrioritizedVacancies" labelTransformer={labelTransformer} {...props} />;
};

export default VacanciesDiff;
